import React from 'react';
import {Box, Typography} from '@mui/material';
import {ShowIfDebugWrapper} from '../../../../contexts/DebugProvider';
import {OpenInCuro} from '../../../../utils/getCuroURL';

interface ChoiceDebugProps {
  newPlanPotId?: string;
  id?: string;
  sameReview?: boolean;
  reccId?: string | null;
  curoId?: string;
}

const ChoiceDebug: React.FC<ChoiceDebugProps> = ({
  newPlanPotId,
  id,
  sameReview,
  reccId,
  curoId,
}) => (
  <>
    <ShowIfDebugWrapper debugKey="forms">
      <Box display="flex" flexWrap="wrap">
        <Typography mr={3} className="plan-id">
          {newPlanPotId || id}
        </Typography>
        {sameReview ? (
          <Typography mr={3}>
            <b>Created in Same review</b>
          </Typography>
        ) : null}
        <Typography>ovrOriginalId:{reccId || ''}</Typography>
      </Box>
    </ShowIfDebugWrapper>
    <OpenInCuro curoId={curoId} curoType="plan" />
  </>
);

export default ChoiceDebug;
